import { useEffect } from "react";

export default function SEOHead({ title, description, path, image, type = "website" }) {
  const siteName = "Hexxium Research";
  const fullTitle = title ? title + " | " + siteName : siteName + " - Premium Research-Grade Peptides";
  const desc = description || "High-purity research-grade peptides for scientific investigation. All products for research use only.";

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name, content, property) => {
      const attr = property ? "property" : "name";
      const key = property || name;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", desc);
    setMeta(null, fullTitle, "og:title");
    setMeta(null, desc, "og:description");
    setMeta(null, type, "og:type");
    setMeta(null, siteName, "og:site_name");
    if (image) setMeta(null, image, "og:image");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
  }, [fullTitle, desc, image, type]);

  return null;
}
